if (!window.SKCatalogMenu) {
    window.SKCatalogMenu = (() => {
        const ACTIVE = 'sk-catalog-menu__item--active';
        const VISIBLE = 'is-visible';
        const OPEN = 'is-open';
        const NO_CHILDREN = 'is-no-children';
        let menu, trigger, panel, colSubcategories, colLeaf, isOpen = false;
        let col1Items, subcatLists, leafLists;

        function init() {
            menu = document.getElementById('sk-catalog-menu');
            trigger = document.querySelector('.product-catalog__trigger');
            if (!menu || !trigger) return;

            panel = menu.querySelector('.sk-catalog-menu__panel');
            colSubcategories = menu.querySelector('.sk-catalog-menu__col--subcategories');
            colLeaf = menu.querySelector('.sk-catalog-menu__col--leaf');

            col1Items = menu.querySelectorAll('[data-col="1"]');
            subcatLists = menu.querySelectorAll('[data-children-of]');
            leafLists = menu.querySelectorAll('[data-grandchildren-of]');

            trigger.addEventListener('click', handleTriggerClick);
            document.addEventListener('click', onClickOutside);
            document.addEventListener('keydown', onKeydown);
            document.addEventListener('sk:menu-opened', onOtherMenuOpened);
            window.addEventListener('scroll', onScroll, {passive: true});
            menu.addEventListener('mouseover', onItemActivate);
            menu.addEventListener('focusin', onItemActivate);
        }

        function handleTriggerClick(e) {
            e.preventDefault();
            e.stopPropagation();
            toggle();
        }

        function toggle() {
            if (isOpen) close();
            else open();
        }

        function open() {
            resetColumns();
            menu.classList.add(OPEN);
            trigger.setAttribute('aria-expanded', 'true');
            isOpen = true;
            if (col1Items.length > 0) activateCategory(col1Items[0]);
            document.dispatchEvent(new CustomEvent('sk:menu-opened', {detail: {source: menu}}));
        }

        function onOtherMenuOpened(e) {
            if (!isOpen) return;
            if (e.detail && e.detail.source === menu) return;
            close();
        }

        function close() {
            menu.classList.remove(OPEN);
            trigger.setAttribute('aria-expanded', 'false');
            isOpen = false;
            resetColumns();
        }

        function resetColumns() {
            for (let i = 0; i < col1Items.length; i++) {
                col1Items[i].classList.remove(ACTIVE);
            }

            hideAllSubcatLists();
            hideAllLeafLists();

            if (colSubcategories) colSubcategories.classList.remove(VISIBLE);
            if (colLeaf) colLeaf.classList.remove(VISIBLE);
            if (panel) panel.classList.remove(NO_CHILDREN);
        }

        function onItemActivate(e) {
            const item = e.target.closest('[data-col]');
            if (!item) return;
            const col = item.getAttribute('data-col');
            if (col === '1') activateCategory(item);
            else if (col === '2') activateSubcategory(item);
        }

        function activateCategory(item) {
            const target = item.getAttribute('data-target');
            if (!target) return;

            for (let i = 0; i < col1Items.length; i++) {
                col1Items[i].classList.remove(ACTIVE);
            }
            item.classList.add(ACTIVE);

            hideAllSubcatLists();
            hideAllLeafLists();
            if (colLeaf) colLeaf.classList.remove(VISIBLE);

            const targetList = menu.querySelector('[data-children-of="' + target + '"]');
            if (targetList) {
                targetList.hidden = false;
                if (colSubcategories) colSubcategories.classList.add(VISIBLE);
                if (panel) panel.classList.remove(NO_CHILDREN);

                const col2Items = targetList.querySelectorAll('[data-col="2"]');
                for (let j = 0; j < col2Items.length; j++) {
                    col2Items[j].classList.remove(ACTIVE);
                }
            } else {
                if (colSubcategories) colSubcategories.classList.remove(VISIBLE);
                if (panel) panel.classList.add(NO_CHILDREN);
            }
        }

        function activateSubcategory(item) {
            const target = item.getAttribute('data-target');
            if (!target) return;

            const parentList = item.closest('[data-children-of]');
            if (parentList) {
                const col2Items = parentList.querySelectorAll('[data-col="2"]');
                for (let i = 0; i < col2Items.length; i++) {
                    col2Items[i].classList.remove(ACTIVE);
                }
            }
            item.classList.add(ACTIVE);

            hideAllLeafLists();
            const targetLeaf = menu.querySelector('[data-grandchildren-of="' + target + '"]');
            if (targetLeaf) {
                targetLeaf.hidden = false;
                if (colLeaf) colLeaf.classList.add(VISIBLE);
            } else {
                if (colLeaf) colLeaf.classList.remove(VISIBLE);
            }
        }

        function hideAllSubcatLists() {
            for (let i = 0; i < subcatLists.length; i++) {
                subcatLists[i].hidden = true;
            }
        }

        function hideAllLeafLists() {
            for (let i = 0; i < leafLists.length; i++) {
                leafLists[i].hidden = true;
            }
        }

        function onScroll() {
            if (isOpen) close();
        }

        function onClickOutside(e) {
            if (!isOpen) return;
            if (trigger.contains(e.target)) return;
            const clickedCol = e.target.closest('.sk-catalog-menu__col');
            if (clickedCol) return;
            close();
        }

        function onKeydown(e) {
            if (e.key === 'Escape' && isOpen) {
                close();
                trigger.focus();
            }
        }

        return {init, open, close, toggle};
    })();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        window.SKCatalogMenu.init();
    });
} else {
    window.SKCatalogMenu.init();
}
